import {getDefaultPieFormatting} from '@/containers/E4ImpactMBA/charts/pie';

const transformData = [
    {
        name: 'Legal, Tax & Accounting',
        value: 'Accounting',
    },
    {
        name: 'Agribusiness',
        value: 'Agrifood',
    },
    {
        name: 'Automotive',
        value: 'Automotive',
    },
    {
        name: 'Art and Culture',
        value: 'Art and Culture',
    },
    {
        name: 'Business Service',
        value: 'Business Service',
    },
    {
        name: 'Consulting',
        value: 'Consulting',
    },
    {
        name: 'Cosmetics',
        value: 'Cosmetics',
    },
    {
        name: 'Education, Research & Development',
        value: 'Education',
    },
    {
        name: 'Banking, Finance & Insurance',
        value: 'Finance',
    },
    {
        name: 'Energy',
        value: 'Energy',
    },
    {
        name: 'Fashion and Textile',
        value: 'Fashion and Textile',
    },
    {
        name: 'Food & Beverage Processing',
        value: 'Food Processing',
    },
    {
        name: 'Healthcare',
        value: 'Health',
    },
    {
        name: 'Housing, Construction & Infrastructure',
        value: 'Housing and Construction',
    },
    {
        name: 'ICT',
        value: 'ICT',
    },
    {
        name: 'Leisure',
        value: 'Leisure',
    },
    {
        name: 'Manufacturing and consumer goods',
        value: 'Manufacturing and consumer goods',
    },
    {
        name: 'Mechanical engeneering',
        value: 'Mechanical engeneering',
    },
    {
        name: 'Media, PR, marketing & communication',
        value: 'Media, PR, digital comunication and marketing',
    },
    {
        name: 'Oil, gas & mining',
        value: 'Oil and gas',
    },
    {
        name: 'Pharmaceuticals',
        value: 'Pharmaceuticals',
    },
    {
        name: 'Personal services',
        value: 'Personal services',
    },
    {
        name: 'Public Administration',
        value: 'Public Administration',
    },
    {
        name: 'Real Estate',
        value: 'Real Estate',
    },
    {
        name: 'Green Energy',
        value: 'Renewable Energy',
    },
    {
        name: 'Tourism and Hospitality',
        value: 'Tourism and Hospitality',
    },
    {
        name: 'Waste Management',
        value: 'Waste Management',
    },
    {
        name: 'Water Management',
        value: 'Water Management',
    },
    {
        name: 'Wholesale and retail trade',
        value: 'Wholesale and retail trade',
    },
    {
        name: 'NGO',
        value: 'NGO',
    },
    {
        name: 'Packaging',
        value: 'Packaging',
    },
    {
        name: 'Transport & Logistics',
        value: 'Transport & Logistics',
    },
];

/**
 * Survey: PROJECT - FINAL IMPACT
 * Question: What is the sector of your business?
 * 
 * == final
 * sector_t1
 * 
 * @param props 
 * @returns 
 */
export const businessSectorChartCalculation = (props: any) => {
    const values = transformData.map(({value}) => value);
    return getDefaultPieFormatting(
        'Business Sector',
        transformData.map(({name, value}) => ({
            name,
            y: props.finalSubmissions.filter((submission: any) => submission.sector_t1 === value).length
        })),
        0,
        {},
    ) as Highcharts.Options;
}